/**
 * Languages available for UI and content display (translations).
 * Used in admin user forms and in the TopBar language selector.
 */
export const AVAILABLE_UI_LANGUAGES = [
  "English",
  "Georgian",
  "Latvian",
  "Russian",
  "Swedish",
  "Ukrainian",
].sort();

/** Flag emoji per language for the language picker modal. */
export const LANGUAGE_FLAGS = {
  English: "🇬🇧",
  Georgian: "🇬🇪",
  Latvian: "🇱🇻",
  Russian: "🇷🇺",
  Swedish: "🇸🇪",
  Ukrainian: "🇺🇦",
};
